import React from 'react';
import './NotFound.css';
const NotFound = () => {
    return (
        <div className="text-center notFound-container for-font">
            <h1>404</h1>
            <h2>Not Found</h2>
            <p>The resource requested could not be found on this server!</p>            
        </div>
    );
};

export default NotFound;